module.exports = __webpack_public_path__ + "assets/img/index-partner21.bf0a6fd4.jpg";